<template>
  <div class="grid w-full grid-cols-1 gap-8 lg:grid-cols-3">
    <div
      v-for="(tool, index) in tools"
      :key="index"
      class="flex h-full w-full flex-col overflow-hidden rounded-2xl border border-[#eaecf0] bg-[linear-gradient(180deg,_#FCFCFD_0%,_#F9FAFB_100%)] lg:min-h-[400px]"
    >
      <div class="flex flex-col gap-1 p-6">
        <h1 class="text-2xl font-medium text-[#101828]">
          {{ tool.name }}
        </h1>
        <p class="text-base text-[#344054]">
          {{ tool.description }}
        </p>
      </div>
      <img
        :src="tool.image"
        alt="tool-img"
        class="h-40 w-full flex-1 object-cover sm:h-[244px]"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { shallowRef } from "vue";
import ExtensiveTemplates from "@/../images/tabbed-bento-images/templates/extensive-templates.png";
import SaveYourTemplates from "@/../images/tabbed-bento-images/templates/save-your-templates.png";
import Assets from "@/../images/tabbed-bento-images/templates/assets.png";

const tools = shallowRef([
  {
    name: "Extensive template library",
    description: "Layers provide freedom to experiment with text, images, or shapes. Explore various arrangements to find your perfect balance.",
    image: ExtensiveTemplates,
  },
  {
    name: "Save your templates",
    description: "Save designs instantly to your account. This feature keeps your work secure and accessible for revisiting and editing anytime.",
    image: SaveYourTemplates,
  },
  {
    name: "Manage your assets",
    description: "Easily adjust your postcard's text by selecting existing boxes or creating new ones.",
    image: Assets,
  },
]);
</script>
